import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconSlowturnsTunedup = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    viewBox="0 0 17 16"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-slowturns-tunedup_svg__a)"
      d="m15.719 7.094-5.5 4.718C9.75 12.22 9 11.876 9 11.25V8.531c-4.875.063-6.938 1.25-5.531 5.781.156.5-.469.907-.875.594C1.219 13.906 0 12 0 10.094c0-4.75 3.969-5.781 9-5.844V1.781c0-.656.75-1 1.219-.593l5.5 4.718c.344.344.344.875 0 1.188Z"
    />
    <defs>
      <linearGradient
        id="icon-slowturns-tunedup_svg__a"
        x1={16}
        x2={0}
        y1={0}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCF4BF" />
        <stop offset={0.18} stopColor="#EFC862" />
        <stop offset={0.73} stopColor="#CD9832" />
        <stop offset={1} stopColor="#BB811B" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconSlowturnsTunedup;
